import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onMounted } from 'vue';
import { useUserStore } from '@/js/lib/store/user';
import IModal from '@/js/components/molecules/IModal.vue';
import SigninSignupForm from '@/js/components/www.iichi.com/pages/signin-signup/SigninSignupForm.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'signin-signup',
  props: {
    active: { default: '' },
    next: { default: '' },
    callback: { type: Function, default: () => {} }
  },
  setup(__props: any) {

const props = __props;
const userStore = useUserStore();
const isShow = ref(false);
const activeRef = ref('signin');
const from = ref('');
const onClose = () => {
  isShow.value = false;
};
const onSubmit = () => {
  if (props.callback) {
    props.callback();
  }
};

onMounted(() => {
  activeRef.value = props.active || (userStore.hasSignined ? 'signin' : 'signup');
  from.value = props.next;
  isShow.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IModal, {
    modelValue: isShow.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isShow).value = $event)),
    "destroy-on-close": true,
    fullscreen: true,
    "show-close": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.wrapper)
      }, [
        _createVNode(SigninSignupForm, {
          modelValue: activeRef.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeRef).value = $event)),
          "is-modal": true,
          from: from.value,
          onSubmit: onSubmit,
          onClose: onClose
        }, null, 8, ["modelValue", "from"])
      ], 2)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})